/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, children, compact }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.1}
      px={compact ? 1.25 : 2}
      sx={() => ({
        fontSize: "0.84rem",
        borderBottom: noBorder ? "none" : "1px solid rgba(126, 170, 220, 0.1)",
        verticalAlign: "middle",
        backgroundColor: "transparent",
      })}
    >
      <MDBox
        display="inline-block"
        width="100%"
        color="white"
        sx={{
          verticalAlign: "middle",
          whiteSpace: "normal",
          lineHeight: 1.4,
          "& .MuiTypography-root": {
            color: "#e6f0ff !important",
          },
          "& .MuiTypography-colorSecondary": {
            color: "#8fa7c4 !important",
          },
        }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  compact: false,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  compact: PropTypes.bool,
};

export default DataTableBodyCell;
